'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withAnalytics;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withAnalytics(WrappedComponent, scrollTop) {
    return function (_React$Component) {
        _inherits(_class2, _React$Component);

        function _class2(props) {
            _classCallCheck(this, _class2);

            var _this = _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this, props));

            _this.hasGTM = function () {
                var result = false;

                if (_this.props.context && _this.props.context.configuration && _this.props.context.configuration.gtm && _this.props.context.configuration.gtm.length > 0) {
                    result = true;
                }

                return result;
            };

            _this.track = function (event, payload) {

                if (_this.hasGTM()) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ event: event, payload: payload });
                }
            };

            _this.getLocation = function () {
                return {
                    origin: window.location.origin,
                    pathname: _this.props.location.pathname,
                    search: _this.props.location.search,
                    hash: _this.props.location.hash
                };
            };

            _this.getLocationString = function () {
                return '' + window.location.origin + _this.props.location.pathname + _this.props.location.search + _this.props.location.hash;
            };

            _this.state = {
                location: null
            };
            return _this;
        }

        _createClass(_class2, [{
            key: 'scrollToTop',
            value: function scrollToTop() {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (this.props.context && this.props.context.analytics && this.props.context.analytics.uuid) {
                    this.track('METRIXUUID', { uuid: this.props.context.analytics.uuid });
                }
                if (this.props.context && this.props.context.session && this.props.context.session.public) {
                    this.track('METRIXPUBLICID', { public: this.props.context.session.public });
                }
                this.setState({ location: this.getLocationString() });
                this.track('METRIXLOCATION', this.getLocation());
                this.scrollToTop();
            }
        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                if (this.getLocationString() !== this.state.location) {
                    this.track('METRIXLOCATION', this.getLocation());
                    this.setState({ location: this.getLocationString() });
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var _this2 = this;

                var analytics = { track: function track(event, payload) {
                        return _this2.track(event, payload);
                    } };
                return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { analytics: analytics }));
            }
        }]);

        return _class2;
    }(_react2.default.Component);
}